import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useEffect, useState } from 'react';
import DiscountApiService from '../../services/discount.api.service';
import useAlert from '../Alert/useAlert';
import { DiscountTableRow } from './DiscountTableRow';
import { StyledHeaderCell } from '../StyledHeaderCell';

export const DiscountTable = ({filters, selectedDiscount, customer, onDiscountChange}) => {
    const {showErrorAlert} = useAlert();
    const [state, setState] = useState({
        discounts: [],
        loading: false,
    });

    useEffect(() => {loadDiscounts()}, [customer, filters]);
    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));
    const startLoading = () => changeState({loading: true});
    const stopLoading = () => changeState({loading: false});

    const onBurn = (discount) => sendRequest(DiscountApiService.burn(discount.hash));
    const onFreeze = (discount) => sendRequest(DiscountApiService.freeze(discount.hash));
    const onThaw = (discount) => sendRequest(DiscountApiService.thaw(discount.hash));

    const sendRequest = (promise) => {
        startLoading();
        promise
            .then(() => loadDiscounts())
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    };

    const loadDiscounts = () => {
        if (!customer?.id) {
            changeState({discounts: []})
            return;
        }
        startLoading();
        DiscountApiService
            .list({customer: customer.id, ...filters})
            .then(discounts => changeState({discounts: discounts.items}))
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    };

    return <Table
        size="small"
        sx={{
            border: '1px solid grey',
            mb: 3,
        }}
    >
        <TableHead>
            <TableRow>
                <StyledHeaderCell>User</StyledHeaderCell>
                <StyledHeaderCell>Status</StyledHeaderCell>
                <StyledHeaderCell>Patient type</StyledHeaderCell>
                <StyledHeaderCell>Country</StyledHeaderCell>
                <StyledHeaderCell>Category</StyledHeaderCell>
                <StyledHeaderCell>Discount</StyledHeaderCell>
                <StyledHeaderCell>Created</StyledHeaderCell>
                <StyledHeaderCell>Expires</StyledHeaderCell>
                <StyledHeaderCell></StyledHeaderCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {state.discounts.map(discount => <DiscountTableRow
                key={discount.hash}
                disabled={state.loading}
                discount={discount}
                onDiscountSelect={onDiscountChange}
                isSelected={discount.hash === selectedDiscount?.hash}
                onBurn={onBurn}
                onFreeze={onFreeze}
                onThaw={onThaw}
                loading={state.loading}
            />)}
        </TableBody>
    </Table>
}
